import { render, staticRenderFns } from "./AddComanda.vue?vue&type=template&id=917caeac&scoped=true"
import script from "./AddComanda.vue?vue&type=script&lang=js"
export * from "./AddComanda.vue?vue&type=script&lang=js"
import style0 from "./AddComanda.vue?vue&type=style&index=0&id=917caeac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917caeac",
  null
  
)

export default component.exports